import React from 'react';
import { useSearchParams } from 'react-router-dom';
import ValueList from 'pages/Value/ValueList';
import Icon from 'components/Icon';
import { Link } from 'react-router-dom';

const ValuePage = () => {
  const [searchParams] = useSearchParams();
  const ddd = searchParams.get('ddd') || '';
  const phone = searchParams.get('phone') || '';

  return (
    <div className="value-page">
      <Link
        className="back-button"
        to={`/recarga/operadoras?ddd=${ddd}&phone=${phone}`}
      >
        <Icon icon="chevron-left" width={64} height={64} />
        Voltar
      </Link>
      <ValueList ddd={ddd} />
    </div>
  );
};

export default ValuePage;
